export const paragraph = (param: string, blurred: boolean, alignment: string) => {
    let p;
    switch (alignment) {
        case 'left':
            p = `<p>${param}</p>`;
            break;
        case 'right':
            p = `<p style="text-align:right;">${param}</p>`;
            break;
        case 'center':
            p = `<p style="text-align:center;">${param}</p>`;
            break;
        default:
            p=`<p>${param}</p>`;
            break;
    }
    return blurIfNeeded(p, blurred)

};


function blurIfNeeded(p: string, blurred:boolean){
    return blurred ?
        p.replace('<p','<p class="blurred" ')
        : p;
}
